import React, { useState, useRef, useEffect } from "react";
import {
  acceptDeclineChat,
  checkRoom,
  CreateChatGroup,
  editChatGroup,
  getChatRoomList,
  getRoomCategoryList,
  getRoomMessageList,
  invitePatientToGroup,
  JoinPatientToGroup,
} from "../../../api/apiHandler";
import Chat from "./Chat";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Header from "../../../components/header/Header";
import Footer from "../../../components/footer/Footer";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { initializeSocket, getSocket } from "../../../helpers/socket";
import AvatarImage from "./AvatarImage";
import styled from "styled-components";
import { createPortal } from "react-dom";
import CreateCommunityGroupModal from "../../../modal/CommunityGroup/CreateCommunityGroupModal";
import PatientNameModal from "../../../modal/PatientModal/PatientModal";

const MedicalSupprotRoom = () => {
  const socket = getSocket();
  const [showActions, setShowActions] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [chatSidebar, setChatSidebar] = useState(false);
  const [editRoom, setEditRoom] = useState({
    id: "",
    name: "",
    description: "",
    image: "",
    status: null,
  });
  const location = useLocation();
  const pathParts = location.pathname?.split("/").filter(Boolean);
  const rawQuery = location.search;

  const [queryId] = rawQuery.replace("?", "")?.split("&");
  const { room } = useParams();
  const navigate = useNavigate();
  const [category, setCategory] = useState([]);
  const [matchedCategory, setMatchedCategory] = useState(null);
  const [label, setLabel] = useState(null);
  const [selectedChat, setSelectedChat] = useState({});
  console.log(queryId, "121vroom");

  const formatCommunityPath = (value) => {
    return (
      value
        .toLowerCase()
        .replace(/&/g, "")
        .replace(/[^\w\s]/gi, "")
        .replace(/\s+/g, "") + "/community"
    );
  };

  useEffect(() => {
    if (localStorage.getItem("user_login_type_role")) {
      Swal.fire({
        title: "Please wait...",
        didOpen: () => {
          Swal.showLoading();
        },
      });
      getRoomCategoryList({}).then((response) => {
        response = JSON.parse(response);
        Swal.close();
        if (response.code == process.env.REACT_APP_SUCCESS) {
          console.log("response123", response.data.data);
          const Category = response?.data?.data?.map((obj) => {
            return {
              value: obj.name,
              label: obj.name,
              id: obj?.id,
              image: obj.image,
            };
          });
          setCategory(Category);
        } else {
        }
      });
    }
  }, []);
  const [selectedRole, setSelectedRole] = useState("");
  useEffect(() => {
    const matched = category.find(
      (cat) => formatCommunityPath(cat.value)?.split("/")[0] === room
    );
    setMatchedCategory(matched);
    setLabel(matched ? matched.label : null);
  }, [room, category]);

  const [isChatVisible, setChatVisible] = useState(false);

  const [groups, setGroups] = useState([]);
  const [messagesList, setMessageList] = useState([]);
  const chatElementRef = useRef(null);

  useEffect(() => {
    setSelectedChat({});
    setMessageList([]);
    setChatVisible(false);
  }, [label]);
  console.log(groups, "groups122334455");

  const hasRun = useRef(false);

  useEffect(() => {
    if (!hasRun.current && groups.length > 0) {
      handleAvatarGroupClick(groups[0]);
      hasRun.current = true;
    }
  }, [groups]);
  useEffect(() => {
    let selected = groups.find((val) => val.id === selectedChat.id);

    setSelectedChat((prev) => ({ ...prev, status: selected?.status }));
  }, [groups]);
  let fetchroomSidebarList = (label) => {
    if (label) {
      getChatRoomList({ category_id: matchedCategory?.id }).then((response) => {
        response = JSON.parse(response);
        // Swal.close();
        if (response.code == process.env.REACT_APP_SUCCESS) {
          setGroups(response?.data?.data || []);
          // if()

          console.log(response?.data?.data, "responcs134dds", selectedChat);
        } else {
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: "error message",
            toast: true,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      });
    }
  };
  useEffect(() => {
    fetchroomSidebarList(label);
  }, [label]);
  const [inviteType, setInviteType] = useState("");
  const [status, setStatus] = useState(null);
  const handleAvatarGroupClick = (val) => {
    console.log(val, "valuuuuu23456");

    if (!socket || !val) return;
    const userId = localStorage.getItem("user_id");

    const chatRoomId = queryId !== "" ? queryId : val.id;

    if (chatRoomId) {
      socket.emit("leaveGroup", { chatRoomId: chatRoomId, userId }, (ack) =>
        console.log("LeaveGroup_ack", ack)
      );
    }

    setSelectedChat(val);

    Swal.fire({
      title: "Please wait...",
      didOpen: () => {
        Swal.showLoading();
      },
      allowOutsideClick: false,
    });

    getRoomMessageList({ chatRoomId })
      .then((response) => {
        Swal.close();
        const res =
          typeof response === "string" ? JSON.parse(response) : response;

        if (res.code == 200) {
          setMessageList(res?.data?.data || []);

          console.log(res, "AbassCheck");
          setStatus(res?.data);
          socket.emit("joinGroup", { chatRoomId, userId }, (ack) =>
            console.log("JoinGroup_ack", ack)
          );
          // fetchroomSidebarList(label);
        } else {
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: res.message || "Failed to load messages",
            toast: true,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      })
      .catch((err) => {
        Swal.close();
        Swal.fire({
          icon: "error",
          title: "Something went wrong",
          text: err?.message || "Unable to fetch messages",
          confirmButtonText: "OK",
        });
      });

    setChatVisible(true);
  };

  const handleCreate = async (data) => {
    try {
      let response;

      if (editRoom?.id) {
        const editData = {
          ...data,
          id: editRoom.id,
        };
        console.log("Editing group:", editData);
        response = await editChatGroup(editData);
      } else {
        console.log("Creating group:", data);
        response = await CreateChatGroup(data);
      }

      console.log("Raw response:", response);

      const parsedValue =
        typeof response === "string" ? JSON.parse(response) : response;

      console.log("Unexpectedresponsecode", parsedValue);
      if (parsedValue?.code == 200) {
        fetchroomSidebarList(label);
        setEditRoom({
          id: "",
          name: "",
          description: "",
          image: "",
          status: null,
        });
      } else {
      }
    } catch (error) {
      console.error("Error in handleCreate:", error);
    }
  };

  let deleteChatRoom = async (val) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to delete this chat room?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    });

    if (result.isConfirmed) {
      try {
        let response = await editChatGroup({
          status: "deleted",
          id: val.id,
        });
        let parsed = JSON.parse(response);
        console.log(parsed, "responceahgdja");

        if (parsed.code === 200) {
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Record Deleted Successfully",
            toast: true,
            showConfirmButton: false,
            timer: 1000,
          });
          setEditRoom({
            id: "",
            name: "",
            description: "",
            image: "",
            status: null,
          });
          setChatVisible(false);
          handleAvatarGroupClick(groups[0]);
          fetchroomSidebarList(label);
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Failed to delete",
          text: error.message || "Something went wrong.",
        });
      }
    }
  };

  const [showIsJoinPatient, setShowIsJoinPatient] = useState(false);

  const [patientName, setPatientName] = useState("");
  const [inviteFrom, setInviteFrom] = useState("");
  const handleJoinPatient = async () => {
    let data = {
      chat_room_id: selectedChat?.id,
      receiver_id: patientName?.id,
      category_id: matchedCategory?.id,
      is_group: inviteFrom === "sidebar" ? 0 : true,
    };
    let responce = await invitePatientToGroup(data);
    let parsed = JSON.parse(responce);
    if (parsed.code === 200) {
      Swal.fire({
        position: "top-end",
        icon: "success",
        title: parsed?.message,
        toast: true,
        showConfirmButton: false,
        timer: 1000,
      });
      setSelectedRole(null);
      setShowIsJoinPatient(false);
      fetchroomSidebarList(label);
    }
    console.log(parsed, "123joincs2hat");
  };
  const joinPatientInRoom = async (queryId) => {
    try {
      const data = { chat_room_id: queryId };

      const response = await JoinPatientToGroup(data);
      const parsed =
        typeof response === "string" ? JSON.parse(response) : response;

      console.log(parsed, "join response");

      if (parsed.code === 200) {
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: parsed.message || "Joined successfully",
          toast: true,
          showConfirmButton: false,
          timer: 1000,
        });

        setShowIsJoinPatient(false);
        fetchroomSidebarList(label);
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed to join",
          text: parsed?.message || "An error occurred.",
          showConfirmButton: true,
          allowOutsideClick: false,
        });
        // navigate(location.pathname, { replace: true });
      }
    } catch (error) {
      console.error("Join error:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong while joining the room.",
      });
    }
  };

  useEffect(() => {
    if (queryId !== "") {
      joinPatientInRoom(queryId);
    }
  }, [queryId]);
  const checkRoomAvailable = async (value) => {
    try {
      if (!value?.userId) {
        console.warn("User ID is missing");
        return;
      }

      const payload = { receiver_id: value.userId };
      const response = await checkRoom(payload);

      const parsed =
        typeof response === "string" ? JSON.parse(response) : response;

      console.log("Roomcheckresponse", parsed);

      if (parsed?.code === 200 && parsed?.data?.chat_room_id) {
        joinPatientInRoom(parsed.data.chat_room_id);
      } else {
        console.warn("Room not found or invalid response.");
      }
    } catch (error) {
      console.error("Error checking room:", error);
    }
  };

  let activeChat = queryId !== "" ? queryId : selectedChat?.id;
  const handleAcceptRejectReq = async (status, chat_room_id) => {
    try {
      const data = { chat_room_id, status };
      const response = await acceptDeclineChat(data);

      const parsed =
        typeof response === "string" ? JSON.parse(response) : response;

      console.log(parsed, "join response");

      if (parsed.code === 200) {
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: parsed.message,
          toast: true,
          showConfirmButton: false,
          timer: 1000,
        });

        fetchroomSidebarList(label);
        setShowIsJoinPatient(false);
        // setChatVisible(false);
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed to join",
          text: parsed?.message || "An error occurred.",
          showConfirmButton: true,
          allowOutsideClick: false,
        });

        // navigate(location.pathname, { replace: true });
      }
    } catch (error) {
      console.error("Error handling accept/reject:", error.message);
    }
  };

  const roles = [
    { id: 1, label: "Patient" },
    { id: 2, label: "Doctor" },
    { id: 3, label: "Chemist" },
  ];

  const handleChange = (e) => {
    const selected = JSON.parse(e.target.value);
    setSelectedRole(selected);
    setShowIsJoinPatient(true);
    setInviteFrom("sidebar");
    setInviteType("invite_users");
  };

  return (
    <>
      {showModal &&
        createPortal(
          <CreateCommunityGroupModal
            show={showModal}
            onHide={setShowModal}
            onSubmit={handleCreate}
            editRoom={editRoom}
          />,
          document.body
        )}
      {showIsJoinPatient &&
        createPortal(
          <PatientNameModal
            patientName={patientName}
            setPatientName={setPatientName}
            setShowIsNameModal={setShowIsJoinPatient}
            showIsNameModal={showIsJoinPatient}
            handleSave={handleJoinPatient}
            from={"MeadicalCommunity"}
            inviteType={inviteType}
            selectedRole={selectedRole}
            setSelectedRole={setSelectedRole}
          />,
          document.body
        )}
      <main className="bg-color">
        <Header />
        <ChatWrpper className="chatbody" style={{ paddingBottom: 70 }}>
          <div className="chat-main">
            <div className={`${chatSidebar && "active"} sideNav2`}>
              <div className="text-end">
                <button
                  onClick={() => setChatSidebar(!chatSidebar)}
                  className="d-lg-none p-0 border-0 bg-transparent"
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12.648 0.572777L8 5.22103C6.45075 3.67228 4.901 2.12203 3.3515 0.572777C1.559 -1.21972 -1.2195 1.55978 0.571496 3.35278C2.12125 4.90103 3.6715 6.45153 5.2195 8.00078C3.67079 9.55073 2.12145 11.1001 0.571496 12.6488C-1.2195 14.4408 1.55925 17.2195 3.3515 15.4288C4.901 13.8788 6.45041 12.3293 7.99975 10.7803L12.6477 15.4288C14.4402 17.2208 17.2195 14.441 15.4277 12.6488C13.8782 11.0991 12.3285 9.54961 10.7785 8.00028C12.3282 6.45044 13.8779 4.90078 15.4277 3.35128C17.2197 1.55978 14.4405 -1.21972 12.6477 0.573777"
                      fill="#929292"
                    />
                  </svg>
                </button>
              </div>
              <div className="">
                <div className="SideNavhead">
                  <h3 className="text-black px-0 font_20">
                    Welcome to the {label} Support Room
                  </h3>
                </div>
                {localStorage.getItem("user_login_type_role") == 2 && (
                  <div className=" d-flex px-3 align-center justify-content-between">
                    <div>
                      <button
                        className="btn commonBtn "
                        onClick={() => {
                          setShowModal(true);
                          setEditRoom({
                            id: "",
                            name: "",
                            description: "",
                            image: "",
                            status: null,
                          });
                        }}
                      >
                        Create Group
                      </button>
                    </div>

                    <div className=" ">
                      <select
                        id="role"
                        className="form-select w-100 commonBtn"
                        value={
                          inviteFrom === "sidebar" && selectedRole
                            ? JSON.stringify(selectedRole)
                            : ""
                        }
                        onChange={handleChange}
                      >
                        <option
                          className="bg-white text-secondary"
                          value=""
                          disabled
                        >
                          Invite User
                        </option>
                        {roles.map((role) => (
                          <option
                            className="bg-white text-dark"
                            key={role.id}
                            value={JSON.stringify({
                              id: role.id,
                              label: role.label,
                            })}
                          >
                            {role.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                )}

                {groups?.map((val, index) => {
                  return (
                    <ChartCard
                      key={val.id}
                      className={`${
                        activeChat == val?.id && "active"
                      } avatar-group  `}
                      onClick={() => {
                        handleAvatarGroupClick(val);
                        navigate(location.pathname, { replace: true });
                        setChatSidebar(!chatSidebar);
                      }}
                    >
                      <div
                        className="user-avatar position-relative rounded-circle"
                        style={{ border: "1px solid #8355b8" }}
                      >
                        <AvatarImage
                          src={
                            val.image
                              ? val.image
                              : val?.user?.profile_image
                              ? val?.user?.profile_image
                              : "/assets/images/logo.png"
                          }
                        />
                      </div>
                      <div className="flex-1">
                        <p className="avatar-name">
                          {val.name ? val.name : val?.user?.first_name}
                        </p>
                        <p className="avatar-msg">{val?.description}</p>
                      </div>
                      {val?.unread_count > 0 && (
                        <div className="">
                          <span className="badge bg-danger rounded-pill">
                            {val?.unread_count}
                          </span>
                        </div>
                      )}
                      {localStorage.getItem("user_login_type_role") == 2 && (
                        <div className="d-flex   align-items-center justify-content-between cursor-pointer">
                          <div className="position-relative">
                            <div
                              className="cursor-pointer"
                              onClick={(e) => {
                                e.stopPropagation();
                                setShowActions(
                                  showActions === index ? null : index
                                );
                              }}
                            >
                              {dots}
                            </div>

                            {showActions === index && (
                              <div
                                className="dropdown-menu show p-2 shadow"
                                style={{
                                  display: "block",
                                  position: "absolute",
                                  top: "100%",
                                  right: 0,
                                }}
                              >
                                {val?.is_group === true && (
                                  <button
                                    className="dropdown-item"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setEditRoom({
                                        id: val.id,
                                        name: val.name,
                                        description: val.description,
                                        image: val.image,
                                        status: val.status ? 1 : 0,
                                      });
                                      setShowModal(true);
                                      setShowActions(null);
                                    }}
                                  >
                                    {editIcon} Rename
                                  </button>
                                )}

                                <button
                                  className="dropdown-item text-danger"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    deleteChatRoom(val);
                                    setShowActions(null);
                                  }}
                                >
                                  {deleteIcon} Delete
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </ChartCard>
                  );
                })}
              </div>
            </div>
            {/* {isChatVisible && ( */}
            <Chat
              chatSidebar={chatSidebar}
              setChatSidebar={setChatSidebar}
              status={status}
              setInviteType={setInviteType}
              setShowIsJoinPatient={setShowIsJoinPatient}
              messagesList={messagesList}
              selectedChat={selectedChat}
              setMessageList={setMessageList}
              queryId={queryId}
              checkRoomAvailable={checkRoomAvailable}
              handleAcceptRejectReq={handleAcceptRejectReq}
              selectedRole={selectedRole}
              setSelectedRole={setSelectedRole}
              fetchroomSidebarList={fetchroomSidebarList}
              label={label}
              setInviteFrom={setInviteFrom}
              inviteFrom={inviteFrom}
              roles={roles}
            />
            {/* )} */}
          </div>
        </ChatWrpper>
        <Footer />
      </main>
    </>
  );
};

const ChartCard = styled.div`
  &.active {
    background: #9fc8ff;
    .avatar-msg {
      color: #fff;
    }
  }
`;
const ChatWrpper = styled.div`
  @media (max-width: 992px) {
    display: block;
    padding-top: 20px;
  .chat-main{
    display: block;
    width: calc(100% - 30px);
    .sideNav2 {
      position: fixed;
      z-index: 99;
      left: 0;
      max-width: 340px;
      transition: 0.4s;
      top: 0;
      &:not(.active) {
        transform: translateX(-100%);
      }
    }
    .Chat {
    height: calc(100% - 60px);
      width: 100%;
    }
  }
  }
  }
`;

export default MedicalSupprotRoom;
let editIcon = (
  <svg
    width="14"
    height="14"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.06 6L12 6.94L2.92 16H2V15.08L11.06 6ZM14.66 0C14.41 0 14.15 0.1 13.96 0.29L12.13 2.12L15.88 5.87L17.71 4.04C18.1 3.65 18.1 3 17.71 2.63L15.37 0.29C15.17 0.09 14.92 0 14.66 0ZM11.06 3.19L0 14.25V18H3.75L14.81 6.94L11.06 3.19Z"
      fill="black"
    />
  </svg>
);

let deleteIcon = (
  <svg
    width="16"
    height="18"
    viewBox="0 0 16 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 18C2.45 18 1.97933 17.8043 1.588 17.413C1.19667 17.0217 1.00067 16.5507 1 16V3H0V1H5V0H11V1H16V3H15V16C15 16.55 14.8043 17.021 14.413 17.413C14.0217 17.805 13.5507 18.0007 13 18H3ZM5 14H7V5H5V14ZM9 14H11V5H9V14Z"
      fill="#D33E3E"
      fill-opacity="0.83"
    />
  </svg>
);
let dots = (
  <svg
    width="13"
    height="3"
    viewBox="0 0 13 3"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 1.25C10 0.918479 10.1317 0.600537 10.3661 0.366117C10.6005 0.131696 10.9185 0 11.25 0C11.5815 0 11.8995 0.131696 12.1339 0.366117C12.3683 0.600537 12.5 0.918479 12.5 1.25C12.5 1.58152 12.3683 1.89946 12.1339 2.13388C11.8995 2.3683 11.5815 2.5 11.25 2.5C10.9185 2.5 10.6005 2.3683 10.3661 2.13388C10.1317 1.89946 10 1.58152 10 1.25ZM5 1.25C5 0.918479 5.1317 0.600537 5.36612 0.366117C5.60054 0.131696 5.91848 0 6.25 0C6.58152 0 6.89946 0.131696 7.13388 0.366117C7.3683 0.600537 7.5 0.918479 7.5 1.25C7.5 1.58152 7.3683 1.89946 7.13388 2.13388C6.89946 2.3683 6.58152 2.5 6.25 2.5C5.91848 2.5 5.60054 2.3683 5.36612 2.13388C5.1317 1.89946 5 1.58152 5 1.25ZM0 1.25C0 0.918479 0.131696 0.600537 0.366117 0.366117C0.600537 0.131696 0.918479 0 1.25 0C1.58152 0 1.89946 0.131696 2.13388 0.366117C2.3683 0.600537 2.5 0.918479 2.5 1.25C2.5 1.58152 2.3683 1.89946 2.13388 2.13388C1.89946 2.3683 1.58152 2.5 1.25 2.5C0.918479 2.5 0.600537 2.3683 0.366117 2.13388C0.131696 1.89946 0 1.58152 0 1.25Z"
      fill="black"
    />
  </svg>
);
